module.exports = __webpack_public_path__ + "img/footer-feedback.f2d73399.png";